import run from "../../animate/run";

/**
 * Select
 * @param {HTMLInputElement} target
 * @param {TriggerProps} trigger
 * @param {MainClassProps} main
 */
const select = (target, trigger, main) => {
  const parameters = /** @type {TriggerParametersProps & Map<String, any>} */ (trigger.get("parameters"));
  const value = parameters?.get("value")?.get("v_output") || null;
  const event = main.events.get(`change:${trigger.get("name")}`);

  if (value) {
    value === target.value ? run(event, "enter") : run(event, "leave");
  } else {
    target.value ? run(event, "enter") : run(event, "leave");
  }
};

export default select;
